import NetHandle from "./net_handle";

const { ccclass } = cc._decorator;

enum NetClientProtoType {
    Login = 1,
    CGameServer,
    LuaGameServer,
    HallServer,
    EventNotify,
}

@ccclass
class NetClient extends NetHandle {

    webSocket: WebSocket;

    name: string;

    onMessage: (messageName: string, ) => void;

    onConnectStateEvent: (state: string, info?: string) => void;

    netClientProtoType: NetClientProtoType

    netState: boolean

    lastReceivePingTime: number = 0

    lastPingTime = 0

    connectTime = 0

    closeReason = ""

    connect(url, protoType?: NetClientProtoType) {
        let self = this;
        if (this.webSocket != null) {
            this.webSocket.onopen = null;
            this.webSocket.onerror = null;
            this.webSocket.onmessage = null;
            this.webSocket.onclose = null;
            // if (this.webSocket.readyState == 1 || this.webSocket.readyState == 0) {//open
            //     this.webSocket.close(1000, "close");
            // }
        }
        this.webSocket = new WebSocket(url);
        this.netClientProtoType = protoType ? protoType : NetClientProtoType.Login;
        this.webSocket.binaryType = "arraybuffer";
        this.webSocket.onmessage = this._onMessage.bind(this);
        this.webSocket.onopen = function (event) {
            self.lastReceivePingTime = Date.now();
            // cc.log("onopen", event)
            self.netState = true
            if (self.onConnectStateEvent) {
                self.onConnectStateEvent("OPEN")
            }
        }

        this.webSocket.onclose = function (event) {
            // cc.log("onclose", event)
            self.netState = false
            if (self.onConnectStateEvent) {
                self.onConnectStateEvent("CLOSE")
            }
            self.webSocket.onmessage = null
        }

        this.webSocket.onerror = function (event: any) {
            self.netState = false
            if (self.onConnectStateEvent) {
                self.onConnectStateEvent("error")
            }
            if (event && typeof event == "object") {
                cc.log("webSocketError", "onerror:" + event.stack)
            } else {
                cc.log("webSocketError", "onerror:" + event)
            }
            self.webSocket.onmessage = null
        }
    }

    private _webSocketClose(reason) {
        this.closeReason = reason
        if (this.webSocket != null) {
            //在Android如果webSocket抛出了异常后又主动调用Close是会奔溃的
            if (this.netState) {
                this.webSocket.onopen = ()=>{};
                this.webSocket.onerror = ()=>{};
                this.webSocket.onmessage = ()=>{};
                this.webSocket.onclose = ()=>{};
                this.webSocket.close(1000, reason);
            } else {
                this.webSocket.onopen = null;
                this.webSocket.onerror = null;
                this.webSocket.onmessage = null;
                this.webSocket.onclose = null;
            }
        }
        this.netState = false
        this.webSocket = null;
    }


    //主动断开链接，不会触发断线重连
    activeClose() {
        this._webSocketClose("ActiveClose")
        if (this.onConnectStateEvent) {
            this.onConnectStateEvent("ActiveClose")
            this.onConnectStateEvent = null
        }
    }

    //是否为主动断开的状态
    isActiveClose() {
        if (!this.netState && this.closeReason == "ActiveClose") {
            return true
        }
        return false
    }

    //会触发断线重连
    disconnect() {
        this._webSocketClose("disconnect")
        if (this.onConnectStateEvent) {
            this.onConnectStateEvent("CLOSE")
            this.onConnectStateEvent = null
        }
    }

    subscibeMsgEvent(messageName, callback: Function, target?: any) {
        this.on(messageName, callback, target);
    }

    unsubscibeMsgEvent(messageName, callback: Function, target?: any) {
        this.off(messageName, callback, target);
    }

    clearMsgEvent() {
        this.clearAllHandles()
    }

    //TODO 需要做拆包处理
    private _onMessage(receiveBuffer: MessageEvent) {
        let messageName, messageData;
        if (this.netClientProtoType == NetClientProtoType.Login) {  // 协议一：messageName(4字节)|dataSzie(4字节)| protoData真正的数据
            let int32Array = new Int32Array(receiveBuffer.data, 0, 2)
            messageName = int32Array[0].toString()
            // cc.log(int32Array[1] + " --- " + (receiveBuffer.data.byteLength - 8));
            messageData = new Uint8Array(receiveBuffer.data, 8, receiveBuffer.data.byteLength - 8);
        }
        else if (this.netClientProtoType == NetClientProtoType.LuaGameServer) {
            //lua协议：包头的长度是动态 总长度(2字节)|Pbc的MessageName长度(2字节)|Pbc的MessageName真正数据(动态长度)|Pbc的MessageData长度(2字节)|Pbc的MessageData真正数据(动态长度)
            let dv = new DataView(receiveBuffer.data)
            let mesNameLen = dv.getInt16(2)

            let uint8ArrayName = new Uint8Array(receiveBuffer.data, 4, mesNameLen);
            messageName = String.fromCharCode.apply(null, uint8ArrayName)  //<= 100k

            let messageDataLen = dv.getInt16(4 + mesNameLen)//new Int16Array(receiveBuffer.data, 4 + mesNameLen, 1);   //messageData长度
            messageData = new Uint8Array(receiveBuffer.data, 6 + mesNameLen, messageDataLen);   //, messageDataLen[0]
        } else if (this.netClientProtoType == NetClientProtoType.EventNotify) {
            messageName = 1
            messageData = new Uint8Array(receiveBuffer.data)
        }

        if (messageName == '1' || messageName == '5' || messageName == 'Login.PingRsp' || messageName == 'Hall.PingRsp') {
            this.lastReceivePingTime = Date.now();
        } 
        let ret = this.handle(messageName, messageData)
        if (!ret) {
            cc.warn("收到没有注册的网络消息包：" + messageName);
        }
    }

    send(data: ArrayBuffer) {
        if (this.webSocket != null && this.netState) {
            this.webSocket.send(data)
        }
    }

    //检查是否心跳超时 已连接状态超时
    checkHeartBeatTimeOut(time: number = 12000) {
        if ((Date.now() > this.lastReceivePingTime + time) && this.netState) {
            cc.log("超时，重连！")
            return true;
        }
        return false;
    }
}

export { NetClient, NetClientProtoType }
